/**
 * Canonical step action descriptions (Getting Started + Steps 1–12).
 * Resolve via t() at runtime; templated share/guidance helpers fill {stepName}.
 */

import { t } from '../i18n/translate';
import {
  guidanceAndVideoDescription,
  practicalGuidanceDescription,
  reviewWithSponsorDescription,
} from './stepActionTemplates';

/** actionId → catalog key for unique descriptions */
const UNIQUE: Record<number, Record<number, string>> = {
  0: {
    1: 'getting_started.action.1.description',
    2: 'getting_started.action.2.description',
    3: 'getting_started.action.3.description',
    4: 'getting_started.action.4.description',
    5: 'getting_started.action.5.description',
    6: 'getting_started.action.6.description',
    7: 'getting_started.action.7.description',
    8: 'getting_started.action.8.description',
  },
  1: {
    1: 'step.1.action.1.description',
    3: 'step.1.action.3.description',
    4: 'step.1.action.4.description',
    5: 'step.1.action.5.description',
    6: 'step.1.action.6.description',
  },
  2: {
    1: 'step.2.action.1.description',
    3: 'step.2.action.3.description',
    5: 'step.2.action.5.description',
  },
  3: {
    1: 'step.3.action.1.description',
    3: 'step.3.action.3.description',
    4: 'step.3.action.4.description',
    5: 'step.3.action.5.description',
    6: 'step.3.action.6.description',
  },
  4: {
    1: 'step.4.action.1.description',
    3: 'step.4.action.3.description',
    5: 'step.4.action.5.description',
  },
  5: {
    1: 'step.5.action.1.description',
    3: 'step.5.action.3.description',
    4: 'step.5.action.4.description',
    5: 'step.5.action.5.description',
    6: 'step.5.action.6.description',
  },
  6: {
    1: 'step.6.action.1.description',
    3: 'step.6.action.3.description',
    5: 'step.6.action.5.description',
  },
  7: {
    1: 'step.7.action.1.description',
    3: 'step.7.action.3.description',
    4: 'step.7.action.4.description',
    5: 'step.7.action.5.description',
  },
  8: {
    1: 'step.8.action.1.description',
    3: 'step.8.action.3.description',
    5: 'step.8.action.5.description',
  },
  9: {
    1: 'step.9.action.1.description',
    3: 'step.9.action.3.description',
    5: 'step.9.action.5.description',
  },
  10: {
    1: 'step.10.action.1.description',
    3: 'step.10.action.3.description',
    5: 'step.10.action.5.description',
  },
  11: {
    1: 'step.11.action.1.description',
    3: 'step.11.action.3.description',
    4: 'step.11.action.4.description',
    5: 'step.11.action.5.description',
  },
  12: {
    1: 'step.12.action.1.description',
    3: 'step.12.action.3.description',
    4: 'step.12.action.4.description',
    5: 'step.12.action.5.description',
  },
};

/** Steps whose share action uses reviewWithSponsorDescription */
const REVIEW_SPONSOR: Record<number, number> = {
  2: 4,
  4: 4,
  6: 4,
  8: 4,
  9: 4,
  10: 4,
};

export function getStepActionDescription(stepNumber: number, actionId: number): string {
  if (REVIEW_SPONSOR[stepNumber] === actionId) {
    return reviewWithSponsorDescription(stepNumber);
  }
  if (actionId === 2) {
    if (stepNumber >= 1 && stepNumber <= 9) return guidanceAndVideoDescription(stepNumber);
    if (stepNumber >= 10 && stepNumber <= 12) return practicalGuidanceDescription(stepNumber);
  }
  const key = UNIQUE[stepNumber]?.[actionId];
  return key ? t(key) : '';
}
